import ColumnMapper from './ColumnMapper';

export default ColumnMapper;
export type { ColumnsMapProps, OptionInfo, TargetField, SeparatorInfo } from './ColumnMapper';
